import { FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { LocationMoment } from 'app/hooks/useGlobalForm';

interface Props {
  open: boolean;
  onClose: () => void;
  locationMoment: LocationMoment;
  resortName: string;
  categoryName: string;
}

const ProductCategoryRestrictionModal: FC<Props> = ({
  open,
  onClose,
  locationMoment,
  resortName,
  categoryName,
}) => {
  const isDelivery = locationMoment === LocationMoment.DeliveryLocation;
  const momentLabel = isDelivery ? 'delivery' : 'return';
  const momentTitle =
    momentLabel.charAt(0).toUpperCase() + momentLabel.slice(1);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') onClose();
      }}
    >
      <DialogTitle>{momentTitle} Restriction</DialogTitle>
      <DialogContent>
        {`Unfortunately, ${resortName} does not permit ${categoryName.toLowerCase()} product ${momentLabel} at this time. Please select a different product or choose another ${momentLabel} location to continue with your reservation. We apologize for the inconvenience.`}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          Got It
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductCategoryRestrictionModal;
